export default [    //注册账号
  {
    path: "/registerAccount",
    name: 'registerAccount',
    meta: {
      isLogin: true // 无需验证登录
    },
    component: () => import("@/views/registerAccount/index.vue")
  }
]
